import {CrossSellType} from "../../definitions/types";
import {mapper} from "../../utils/helpers";
import {CrossSellModel} from "../domain/crossSellModel";

export class CompatibleWithModel {
    private readonly _compatibleWith: CrossSellModel[];

    constructor(public readonly crossSellTypes: CrossSellType[]) {
        this._compatibleWith = crossSellTypes.map(compatibleWith => mapper.crossSellToModel(compatibleWith));
    }

    /**
     * @method compatibleWith
     * @description Gets the compatible with items for the model instance.
     * @returns {CrossSellModel[]}
     */
    public get compatibleWith(): CrossSellModel[] {
        return this._compatibleWith;
    }

    /**
     * @method count
     * @description Gets the count of compatible with items for the model instance.
     * @returns {number}
     */
    public get count(): number {
        return this._compatibleWith.length;
    }

    /**
     * @method hasCompatibleWith
     * @description Returns true if the model instance has compatible with items.
     * @returns {boolean}
     */
    public get hasCompatibleWith(): boolean {
        return this.count > 0;
    }
}